var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#00916E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6995 20.3874C11.7009 15.1078 14.5623 11.0277 18.9518 9.58193C25.2413 7.51038 32.004 11.1215 33.1371 18.0157C33.6932 21.3994 32.8129 24.4455 30.6175 27.1023C28.2426 29.9763 25.8527 32.5588 23.4698 35.4264C22.8349 36.1904 22.1562 36.191 21.5251 35.4306C19.046 32.4434 16.5403 29.7569 14.0949 26.7428C12.4649 24.7337 11.7244 22.3857 11.6995 20.3874ZM22.504 15.3008C20.1493 15.3041 18.2546 17.1821 18.2573 19.5101C18.2599 21.8122 20.1655 23.6881 22.5027 23.6895C24.8257 23.6908 26.7389 21.7942 26.734 19.495C26.7291 17.181 24.8297 15.2976 22.504 15.3008Z",
    fill: "#F2F9F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationBg);
export default __webpack_public_path__ + "static/media/icon-location-bg.6ac582b5549376e55f4ac3bf0d6fa0a8.svg";
export { ForwardRef as ReactComponent };